import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button } from "antd";

import partnersApi from "../../../apis/Partners.api";
import { isEndWithConsonant } from "../../../utils/status";
import { toastAlert } from "../../AlertComponent";
import GroupBuyingModal from "../GroupBuyingModal";

const HomeGroupBuyingAlert = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const influencerId = reduxChannel.influencer_id;
	const [alertShow, setAlertShow] = useState(false);
	// const pathname = window.location?.pathname;
	const cUser = useSelector((state) => state.auth.channelUser);

	const eventUserAlert = async () => {
		if (cUser?.id) {
			const param = {
				cooperate_id: null,
				influencer_id: reduxChannel?.user_id,
				name: cUser?.name ?? "",
				phone: cUser.phone,
			};
			const res = await partnersApi.createGroupBuyingAlert(param);
			if (res.code === 200) {
				toastAlert("정상적으로 등록되었습니다!");
			} else {
				toastAlert("이미 등록된 번호입니다.");
			}
		} else {
			if (reduxChannel?.user_id === 9) {
				history.push(`/together/channel/login?id=squidtv`);
			} else {
				setAlertShow(true);
			}
		}
	};
	if (!influencerId) {
		return (
			<>
				<div
					className={`home-each group-buying-alert-footer`}
					style={{
						// backgroundColor: "#eaeff6",
						backgroundColor: "#e5f0ff",
						// paddingTop: 0
					}}
				>
					<div className={`max-width-apply`}>
						<h3
							className={`each-title`}
							style={{
								width: "fit-content",
								margin: "auto",
								paddingBottom: "1em",
								textAlign: "center",
							}}
							id={`m-white-pre`}
						>
							{reduxChannel?.name}
							{/*{isEndWithConsonant(reduxChannel?.name) ? "과" : "와"} 함께하는{"\n"}공동구매 놓치지 마세요!*/}
							{isEndWithConsonant(reduxChannel?.name) ? "과" : "와"} 함께하는
							{"\n"}이벤트 놓치지 마세요!
						</h3>

						<Button
							className={`group-buying-alert alert-ready`}
							style={{ margin: "auto", backgroundColor: "#e5f0ff" }}
							onClick={eventUserAlert}
						>
							<img
								src={`/assets/images/channel/alert-black.png`}
								alt={`공동구매 알림 받기`}
								className={`group-buying-alert-icon`}
								style={{
									height: "auto",
									width: "1.2em",
								}}
							/>
							{/*공동구매 알림받기*/}
							이벤트 알림받기
						</Button>
					</div>

					{alertShow && (
						<GroupBuyingModal
							alertShow={alertShow}
							setAlertShow={setAlertShow}
						/>
					)}
				</div>
			</>
		);
	} else return <></>;
};
export default HomeGroupBuyingAlert;
